import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { Actions, Link } from 'ui-kit/actions'
import { Picture } from 'ui-kit/picture'
import { LINKS } from 'routes/constants'
import { BookCalendlyLink } from 'routes/components/Shared'
import ImageMob from './image-mob.png'
import clsx from 'clsx'
import classes from './LandingHero.module.scss'

export const LandingHero = () => {
  return (
    <Block as={'section'} divider={'mobile'} className={classes.section}>
      <Heading as={'h1'} size={'xxl'} balance center className={classes.title}>
        Build every single integration your customers need with AI
      </Heading>
      <Block pad={'base'} className={classes.content}>
        <div className={classes.heading}>
          <Heading as={'h2'} balance center className={classes.caption}>
            Membrane
          </Heading>
          <Heading
            as={'h2'}
            size={'xs'}
            center
            balance
            className={classes.subtitle}
          >
            The first AI-native integration layer for your product
          </Heading>
          <Actions className={classes.actions}>
            <BookCalendlyLink
              type={'secondary'}
              className={clsx(classes.button, classes.button__demo)}
            >
              Book a demo
            </BookCalendlyLink>
            <Link
              type={'secondary'}
              href={LINKS.MEMBRANE}
              asPageButton
              className={classes.button}
            >
              Learn more
            </Link>
          </Actions>
        </div>

        <Picture
          className={classes.image}
          mobSvg={ImageMob.src}
          noBreakpoint
          alt='The first AI-native integration layer for your product'
          fetchPriorityHigh
        />
      </Block>
    </Block>
  )
}
